import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * this needs to wrap <Container /> in order to make the fadeout effect work
 * on smaller screens or when multiple tabs are available and users need to
 * scroll/swipe trough the list of tabs
 */
export const PositionRelative = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gn2qr00"
} : {
  target: "e1gn2qr00",
  label: "PositionRelative"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBvc2l0aW9uUmVsYXRpdmUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTJDIiwiZmlsZSI6IlBvc2l0aW9uUmVsYXRpdmUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG4vKipcbiAqIHRoaXMgbmVlZHMgdG8gd3JhcCA8Q29udGFpbmVyIC8+IGluIG9yZGVyIHRvIG1ha2UgdGhlIGZhZGVvdXQgZWZmZWN0IHdvcmtcbiAqIG9uIHNtYWxsZXIgc2NyZWVucyBvciB3aGVuIG11bHRpcGxlIHRhYnMgYXJlIGF2YWlsYWJsZSBhbmQgdXNlcnMgbmVlZCB0b1xuICogc2Nyb2xsL3N3aXBlIHRyb3VnaCB0aGUgbGlzdCBvZiB0YWJzXG4gKi9cbmV4cG9ydCBjb25zdCBQb3NpdGlvblJlbGF0aXZlID0gc3R5bGVkLmRpdiBgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1Qb3NpdGlvblJlbGF0aXZlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});